// import React, { useState } from "react";
// import {
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     TextField,
//     Box,
//     IconButton,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Grid,
//     Stack,
//     Button,
//     Checkbox,
//     Typography,
//     FormControlLabel
// } from "@mui/material";
// import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
// import { freightRecycle, freightRestore } from "../../../Services/Services";
// import { useEffect } from "react";
// import Popover from '@mui/material/Popover';
// import { Autocomplete } from '@mui/material';
// export default function FreightRestore() {
//     const [data, setData] = useState([]);
//     const [anchorEl1, setAnchorEl1] = useState(null);
//     const [deleteId, setDelete] = useState(null);

//     useEffect(() => {
//         const fetchFreightList = async () => {
//             const data = await freightRecycle();
//             setData(data);
//         };

//         fetchFreightList();
//     }, []);


//     const handleDelete = async (id) => {
//         const data = await freightRestore(id);
//         setData(data);
//     };
//     function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
//         const date = new Date(dateTimeString);

//         const day = date.getDate().toString().padStart(2, '0');
//         const month = (date.getMonth() + 1).toString().padStart(2, '0');
//         const year = date.getFullYear();

//         if (format === "dd-mm-yyyy") {
//             return `${day}-${month}-${year}`;
//         } else if (format === "yyyy-mm-dd") {
//             return `${year}-${month}-${day}`;
//         } else {
//             throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
//         }
//     }

//     return (
//         <div style={{ width: "100%" }}>


//             <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}>
//                 <div style={{ overflowX: "auto" }}>
//                     <Table
//                         size="small"
//                         id="freight-list"
//                         sx={{
//                             tableLayout: "auto",
//                             width: "auto",
//                             "& td, & th": {
//                                 textAlign: "center",
//                                 whiteSpace: "nowrap",
//                                 padding: "4px 8px",
//                                 fontSize: "0.8125rem",
//                                 borderBottom: "1px solid #ccc",
//                             },
//                         }}
//                     >
//                         <TableHead>
//                             <TableRow
//                                 sx={{
//                                     "& th": {
//                                         fontWeight: "bold",
//                                         color: (theme) =>
//                                             theme.palette.mode === "dark" ? "#2196f3" : "#333",
//                                         backgroundColor: (theme) =>
//                                             theme.palette.mode === "dark" ? "black" : "#f5f5f5",
//                                     },
//                                 }}
//                             >
                               
//                                 <TableCell>SR. No</TableCell>
//                                 <TableCell>Freight Id</TableCell>
//                                 <TableCell>Party Name</TableCell>
//                                 <TableCell>Branch Name</TableCell>
//                                 <TableCell>Loading Date</TableCell>
//                                 <TableCell>Unloading Date</TableCell>
//                                 <TableCell>Truck No.</TableCell>
//                                 <TableCell>D.O. No.</TableCell>
//                                 <TableCell className="no-print">T.P. No.</TableCell>
//                                 <TableCell>From</TableCell>
//                                 <TableCell>To</TableCell>
//                                 <TableCell>Loading Wt</TableCell>
//                                 <TableCell>Receiving Wt</TableCell>
//                                 <TableCell>Shortage Wt</TableCell>
//                                 <TableCell>Billing Wt</TableCell>
//                                 <TableCell>Freight Rate</TableCell>
//                                 <TableCell>Freight Amt</TableCell>
//                                 <TableCell className="no-print">TDS %</TableCell>
//                                 <TableCell>TDS Amt</TableCell>
//                                 <TableCell>Shortage Rate</TableCell>
//                                 <TableCell>Shortage Amt</TableCell>
//                                 <TableCell className="no-print">Ad Mines</TableCell>
//                                 <TableCell className="no-print">Ad Diesel</TableCell>
//                                 <TableCell className="no-print">Ad Cash</TableCell>
//                                 <TableCell>Total Ad</TableCell>
//                                 <TableCell>Commission</TableCell>
//                                 <TableCell>Net Amt</TableCell>
//                                 <TableCell>Others Exp.</TableCell>
//                                 <TableCell>Net Payable</TableCell>
//                                 {/* <TableCell>Paid Amt</TableCell>
//                 <TableCell>Bal Amt</TableCell> */}
//                                 <TableCell className="no-print">Truck Owner</TableCell>
//                                 <TableCell className="no-print">Phone No.</TableCell>
//                                 <TableCell className="no-print">PAN No.</TableCell>
//                                 <TableCell className="no-print">Remark</TableCell>
//                                 <TableCell>Date</TableCell>
//                                 <TableCell
//                                     className="no-print"
//                                     sx={{
//                                         position: "sticky",
//                                         right: 0,
//                                         backgroundColor: "#f5f5f5",
//                                         zIndex: 2,
//                                     }}
//                                 >
//                                     Actions
//                                 </TableCell>
//                             </TableRow>
//                         </TableHead>

//                         <TableBody>
//                             {data.length === 0 ? (
//                                 <TableRow>
//                                     <TableCell colSpan={32} align="center">
//                                         No matching records found.
//                                     </TableCell>
//                                 </TableRow>
//                             ) : (
//                                 data.map((row, index) => (
//                                     <TableRow
//                                         key={index}
//                                         sx={{
//                                             backgroundColor: row.is_remember ? "#ffe0b2" : index % 2 === 0 ? "#fafafa" : "#ffffff",
//                                             "& td": {
//                                                 color: (theme) =>
//                                                     theme.palette.mode === "dark" ? "white" : "inherit",
//                                                 backgroundColor: row.is_remember
//                                                     ? "#ffe0b2"
//                                                     : (theme) => (theme.palette.mode === "dark" ? "black" : "inherit"),
//                                             },
//                                         }}
//                                     >
                                     
//                                         <TableCell>{index + 1}</TableCell>
//                                         <TableCell>{row.freight_id}</TableCell>
//                                         <TableCell>{row.party_name}</TableCell>
//                                         <TableCell>{row.branch_name}</TableCell>
//                                         <TableCell>{row.loading_date}</TableCell>
//                                         <TableCell>{row.unloading_date}</TableCell>
//                                         <TableCell>{row.truck_no}</TableCell>
//                                         <TableCell>{row.do_no}</TableCell>
//                                         <TableCell className="no-print">{row.tp_no}</TableCell>
//                                         <TableCell>{row.from_location}</TableCell>
//                                         <TableCell>{row.to_location}</TableCell>
//                                         <TableCell>{row.loading_wt}</TableCell>
//                                         <TableCell>{row.received_wt}</TableCell>
//                                         <TableCell>{row.shortage_wt}</TableCell>
//                                         <TableCell>{row.billing_wt}</TableCell>
//                                         <TableCell>{row.freight_rate}</TableCell>
//                                         <TableCell>{row.freight_amt}</TableCell>
//                                         <TableCell className="no-print">{row.tds_per}</TableCell>
//                                         <TableCell>{row.tds_amt}</TableCell>
//                                         <TableCell>{row.shortage_rate}</TableCell>
//                                         <TableCell>{row.shortage_amt}</TableCell>
//                                         <TableCell className="no-print">{row.ad_mines_exp}</TableCell>
//                                         <TableCell className="no-print">{row.ad_diesel_exp}</TableCell>
//                                         <TableCell className="no-print">{row.ad_cash_exp}</TableCell>
//                                         <TableCell>{row.total_advance}</TableCell>
//                                         <TableCell>{row.commission}</TableCell>
//                                         <TableCell>{row.net_amount}</TableCell>
//                                         <TableCell>{row.other_exp}</TableCell>
//                                         <TableCell>{row.net_payable}</TableCell>
//                                         {/* <TableCell>{row.paid_amount}</TableCell>
//                     <TableCell>{row.bal_amount}</TableCell> */}
//                                         <TableCell className="no-print">{row.truck_owner}</TableCell>
//                                         <TableCell className="no-print">{row.phone_no}</TableCell>
//                                         <TableCell className="no-print">{row.pan_no}</TableCell>
//                                         <TableCell className="no-print">{row.remark}</TableCell>
//                                         <TableCell >{formatOnlyDate(row.created_at)}</TableCell>
//                                         <TableCell
//                                             className="no-print"
//                                             sx={{
//                                                 position: "sticky",
//                                                 right: 0,
//                                                 backgroundColor: "#fff",
//                                                 zIndex: 1,
//                                             }}
//                                         >
//                                             <Stack
//                                                 direction="row"
//                                                 spacing={1}
//                                                 justifyContent="center"
//                                             >


//                                                 <IconButton
//                                                     size="small"
//                                                     color="error"
//                                                     onClick={(event) => {
//                                                         setAnchorEl1(event.currentTarget);
//                                                         setDelete(row.freight_id); // ✅ Assuming `row.id` is the correct ID
//                                                     }}
//                                                 >
//                                                     <RestoreFromTrashIcon fontSize="small" style={{ color: "blue" }} />

//                                                 </IconButton>


//                                             </Stack>
//                                         </TableCell>
//                                     </TableRow>
//                                 ))
//                             )}
//                         </TableBody>
//                     </Table>
//                 </div>
//             </TableContainer>





//             <Popover
//                 open={Boolean(anchorEl1)}
//                 anchorEl={anchorEl1}
//                 onClose={() => {
//                     setAnchorEl1(null);
//                     setDelete(null);
//                 }}
//                 anchorOrigin={{
//                     vertical: 'bottom',
//                     horizontal: 'center',
//                 }}
//                 transformOrigin={{
//                     vertical: 'top',
//                     horizontal: 'center',
//                 }}
//             >
//                 <Box sx={{ p: 1 }}>
//                     <Typography variant="body2">Are you sure ?</Typography>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
//                         <Button
//                             color="error"
//                             size="small"
//                             onClick={async () => {
//                                 try {
//                                     await handleDelete(deleteId);
//                                 } finally {
//                                     setAnchorEl1(null);
//                                     setDelete(null);
//                                 }
//                             }}
//                         >
//                             Yes
//                         </Button>
//                         <Button
//                             size="small"
//                             onClick={() => {
//                                 setAnchorEl1(null);
//                                 setDelete(null);
//                             }}
//                         >
//                             No
//                         </Button>
//                     </Box>
//                 </Box>
//             </Popover>
//         </div>
//     );
// }











import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Button,
  IconButton,
  Box,
  Typography,
  Popover,
  Paper,
} from "@mui/material";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import { freightRecycle, freightRestore } from "../../../Services/Services";

export default function FreightRestore() {
  const [data, setData] = useState([]);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [deleteId, setDelete] = useState(null);

  useEffect(() => {
    const fetchFreightList = async () => {
      const data = await freightRecycle();
      setData(data);
    };
    fetchFreightList();
  }, []);

  const handleDelete = async (id) => {
    const data = await freightRestore(id);
    setData(data);
  };

  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return format === "dd-mm-yyyy"
      ? `${day}-${month}-${year}`
      : `${year}-${month}-${day}`;
  }

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          overflowX: "auto",
          overflowY: "auto",
          maxHeight: "85vh",
          position: "relative",
          border: "1px solid #ddd",
        }}
      >
        <Table
          stickyHeader
          size="small"
          sx={{
            tableLayout: "auto",
            "& td, & th": {
              textAlign: "center",
              whiteSpace: "nowrap",
              padding: "6px 8px",
              fontSize: "0.8125rem",
              borderBottom: "1px solid #ccc",
            },
            "& th": {
              position: "sticky",
              top: 0,
              zIndex: 3,
              fontWeight: "bold",
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          {/* ✅ FIXED TOP HEADER */}
          <TableHead>
            <TableRow>
              <TableCell>SR. No</TableCell>
              <TableCell>Freight Id</TableCell>
              <TableCell>Party Name</TableCell>
              <TableCell>Branch Name</TableCell>
              <TableCell>Loading Date</TableCell>
              <TableCell>Unloading Date</TableCell>
              <TableCell>Truck No.</TableCell>
              <TableCell>D.O. No.</TableCell>
              <TableCell>T.P. No.</TableCell>
              <TableCell>From</TableCell>
              <TableCell>To</TableCell>
              <TableCell>Loading Wt</TableCell>
              <TableCell>Receiving Wt</TableCell>
              <TableCell>Shortage Wt</TableCell>
              <TableCell>Billing Wt</TableCell>
              <TableCell>Freight Rate</TableCell>
              <TableCell>Freight Amt</TableCell>
              <TableCell>TDS %</TableCell>
              <TableCell>TDS Amt</TableCell>
              <TableCell>Shortage Rate</TableCell>
              <TableCell>Shortage Amt</TableCell>
              <TableCell>Ad Mines</TableCell>
              <TableCell>Ad Diesel</TableCell>
              <TableCell>Ad Cash</TableCell>
              <TableCell>Total Ad</TableCell>
              <TableCell>Commission</TableCell>
              <TableCell>Net Amt</TableCell>
              <TableCell>Others Exp.</TableCell>
              <TableCell>Net Payable</TableCell>
              <TableCell>Truck Owner</TableCell>
              <TableCell>Phone No.</TableCell>
              <TableCell>PAN No.</TableCell>
              <TableCell>Remark</TableCell>
              <TableCell>Date</TableCell>

              {/* ✅ FIXED RIGHT ACTION HEADER */}
              <TableCell
                sx={{
                  position: "sticky",
                  right: 0,
                  zIndex: 4,
                  backgroundColor: "#f5f5f5",
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={35} align="center">
                  No matching records found.
                </TableCell>
              </TableRow>
            ) : (
              data.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor:
                      index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:hover": { backgroundColor: "#f1f1f1" },
                  }}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.freight_id}</TableCell>
                  <TableCell>{row.party_name}</TableCell>
                  <TableCell>{row.branch_name}</TableCell>
                  <TableCell>{row.loading_date}</TableCell>
                  <TableCell>{row.unloading_date}</TableCell>
                  <TableCell>{row.truck_no}</TableCell>
                  <TableCell>{row.do_no}</TableCell>
                  <TableCell>{row.tp_no}</TableCell>
                  <TableCell>{row.from_location}</TableCell>
                  <TableCell>{row.to_location}</TableCell>
                  <TableCell>{row.loading_wt}</TableCell>
                  <TableCell>{row.received_wt}</TableCell>
                  <TableCell>{row.shortage_wt}</TableCell>
                  <TableCell>{row.billing_wt}</TableCell>
                  <TableCell>{row.freight_rate}</TableCell>
                  <TableCell>{row.freight_amt}</TableCell>
                  <TableCell>{row.tds_per}</TableCell>
                  <TableCell>{row.tds_amt}</TableCell>
                  <TableCell>{row.shortage_rate}</TableCell>
                  <TableCell>{row.shortage_amt}</TableCell>
                  <TableCell>{row.ad_mines_exp}</TableCell>
                  <TableCell>{row.ad_diesel_exp}</TableCell>
                  <TableCell>{row.ad_cash_exp}</TableCell>
                  <TableCell>{row.total_advance}</TableCell>
                  <TableCell>{row.commission}</TableCell>
                  <TableCell>{row.net_amount}</TableCell>
                  <TableCell>{row.other_exp}</TableCell>
                  <TableCell>{row.net_payable}</TableCell>
                  <TableCell>{row.truck_owner}</TableCell>
                  <TableCell>{row.phone_no}</TableCell>
                  <TableCell>{row.pan_no}</TableCell>
                  <TableCell>{row.remark}</TableCell>
                  <TableCell>{formatOnlyDate(row.created_at)}</TableCell>

                  {/* ✅ FIXED RIGHT ACTION COLUMN */}
                  <TableCell
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#fff",
                      zIndex: 3,
                      boxShadow: "-2px 0 4px rgba(0,0,0,0.05)",
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          setAnchorEl1(event.currentTarget);
                          setDelete(row.freight_id);
                        }}
                      >
                        <RestoreFromTrashIcon
                          fontSize="small"
                          sx={{ color: "blue" }}
                        />
                      </IconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ✅ POPUP CONFIRMATION */}
      <Popover
        open={Boolean(anchorEl1)}
        anchorEl={anchorEl1}
        onClose={() => {
          setAnchorEl1(null);
          setDelete(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 1 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 1,
            }}
          >
            <Button
              color="error"
              size="small"
              onClick={async () => {
                try {
                  await handleDelete(deleteId);
                } finally {
                  setAnchorEl1(null);
                  setDelete(null);
                }
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl1(null);
                setDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
}


